<template>
  <a-modal
    title="교환 / 반납 신청하기"
    :visible="visible"
    :okText="currentLevel != 1 ? '다음' : '신청하기'"
    @ok="onNext"
    @cancel="visible = false;"
    cancelText="취소"
  >
    <a-steps :current="currentLevel" size="small" style="margin-bottom: 5%;">
      <a-step title="도매 선택" />
      <a-step title="상품 입력" />
    </a-steps>

    <div v-if="currentLevel === 0">
      <a-row :gutter="16">
        <a-col :span="24" :md="18" style="margin-top: 5px;">
          <a-auto-complete
            placeholder="도매 이름을 입력하여 주세요."
            v-model="search"
            @search="onAutoComplete"
            :dataSource="autoComplete"
            v-on:keypress.native="onSearchChange"
            style="width: 100%"
          />
        </a-col>
        <a-col :span="24" :md="5" style="margin-top: 5px;">
          <a-button type="primary" icon="search" style="width: 92%" @click="onSearch">검색</a-button>
        </a-col>
      </a-row>
      <div v-if="wholesales.length > 0">
        <a-list itemLayout="horizontal" :dataSource="wholesales">
          <a-list-item slot="renderItem" slot-scope="wholesale">
            <a-list-item-meta
              :description="wholesale.location.building +
          ' (' + wholesale.location.mall + ') ' +
          wholesale.location.floor + '층 ' +
          wholesale.location.row + '열 ' +
          wholesale.location.place + '호'"
            >
              <a slot="title">{{wholesale.name}}</a>
            </a-list-item-meta>
            <a-button
              :icon="selectedWholesale.includes(wholesale) ? 'check' : 'plus'"
              :type="selectedWholesale.includes(wholesale) ? 'primary' : 'dashed'"
              @click="onSelected(wholesale)"
            >{{ selectedWholesale.includes(wholesale) ? '선택됨' : '선택' }}</a-button>
          </a-list-item>
        </a-list>
      </div>
      <div class="card-empty" v-else>
        <i class="no-content-logo"></i>
        <p>
          <b>위에서 도매 이름을 검색해주세요.</b>
        </p>
      </div>
    </div>
    <div
      v-else-if="currentLevel === 1"
      v-for="wholesale in selectedWholesale"
      :key="wholesale.idx"
      style="margin-bottom: 2em;"
    >
      <a-card
        size="small"
        :title="`${wholesale.name} (${wholesale.location.building} ${wholesale.location.mall})`"
        style="width: 100%"
      >
        <a slot="extra">
          <a-badge
            style="margin-left: 10px;"
            :count="`${wholesale.location.floor}층 ${wholesale.location.row}열 ${wholesale.location.place}호`"
            :numberStyle="{backgroundColor: '#52c41a'} "
          />
        </a>
        <a-textarea
          v-model="reason[wholesale.idx]"
          placeholder="상세 설명을 입력하여 주세요. 사입 삼촌에게 전달됩니다."
          :autosize="{ minRows: 6, maxRows: 6 }"
          @change="$forceUpdate()"
        />
        <div v-for="(detail, index) in details[wholesale.idx]" :key="index">
          <a-row :gutter="16">
            <a-col :span="14">
              <a-input
                size="small"
                style="width:100%; margin-right: 10px; margin-top: 10px;"
                placeholder="품목/컬러/사이즈"
                v-model="details[wholesale.idx][index].name"
                @change="$forceUpdate()"
              />
            </a-col>
            <a-col :span="8">
              <a-input-number
                :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                size="small"
                style="width: 100%; margin-right: 10px; margin-top: 10px;"
                placeholder="수량"
                v-model="details[wholesale.idx][index].amount"
                @change="$forceUpdate()"
              />
            </a-col>
            <a-col :span="2">
              <a-button
                style="margin-top: 10px;"
                size="small"
                shape="circle"
                type="link"
                icon="minus-circle"
                @click="decrease(wholesale.idx, index);"
              />
            </a-col>
          </a-row>
        </div>
        <a-button
          style="width: 97%; margin-top: 10px;"
          type="dashed"
          size="small"
          icon="plus"
          @click="increase(wholesale.idx)"
          block
        >추가</a-button>
      </a-card>
    </div>
  </a-modal>
</template>
<script>
import config from "../../config";
import OPCODE from "../../libs/OPCODE";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import Axios from "axios";
import { mapActions } from "vuex";

export default {
  name: "ExchangeAdd",
  data() {
    return {
      visible: true,
      wholesales: [],
      autoComplete: [],
      currentLevel: 0,
      search: "",
      selectedWholesale: [] /* 도매 선택 */,
      reason: {} /* 요청 메세지 */,
      details: {} /* 아이템 */,
      latestComplete: new Date()
    };
  },
  methods: {
    ...mapActions(["refreshExchanges"]),
    async onAutoComplete() {
      if (this.search === "") return;
      if (this.search.length <= 2) return;
      const currentTime = new Date();
      if (currentTime - this.latestComplete <= 1000) return;
      this.latestComplete = currentTime;
      const {
        data
      } = await Axios.get(
        `${config.hostname}/v1/wholesale/add/pre?search=` + this.search,
        { withCredentials: true }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this.autoComplete = data.wholesales;
            break;
        }
      }
    },
    onSelected(wholesale) {
      if (!this.selectedWholesale.includes(wholesale)) {
        this.selectedWholesale.push(wholesale);
      } else {
        const index = this.selectedWholesale.indexOf(wholesale);
        this.selectedWholesale.splice(index, 1);
      }
    },
    onSearchChange(e) {
      if (e.key !== "Enter") return;
      this.onSearch();
    },
    async onSearch() {
      const {
        data
      } = await Axios.get(
        `${config.hostname}/v1/wholesale/add?search=` + this.search,
        { withCredentials: true }
      );
      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this.wholesales = data.wholesales;
            break;
        }
      }
    },
    increase(idx) {
      this.details[idx].push({
        name: "",
        amount: 1
      });
      this.$forceUpdate();
    },
    decrease(wholesaleIdx, idx) {
      if (this.details[wholesaleIdx].length <= 1) {
        return config.alert.mixin({
          type: "error",
          title: "주문 내역은 최소 1개 이상이여야 합니다."
        });
      }

      this.details[wholesaleIdx].splice(idx, 1);
    },
    async onNext() {
      if (this.currentLevel === 0) {
        if (this.selectedWholesale.length <= 0)
          return config.alert.mixin({
            type: "error",
            title: "도매를 최소 1개 이상이여야 합니다."
          });

        this.currentLevel = 1;
        for (const wholesale of this.selectedWholesale) {
          if (!this.details[wholesale.idx]) {
            this.details[wholesale.idx] = [
              {
                name: "",
                amount: 1
              }
            ];

            this.reason[wholesale.idx] = "";
          }
        }
      } else if (this.currentLevel === 1) {
        for (const { idx } of this.selectedWholesale) {
          if (this.reason[idx].length <= 0)
            return config.alert.mixin({
              type: "error",
              title: "메세지를 입력해주세요."
            });

          for (const { name, amount } of this.details[idx]) {
            if (name.length > 0 && amount > 0) continue;
            return config.alert.mixin({
              type: "error",
              title: "모든 입력란을 입력하여 주세요."
            });
          }
        }

        const body = [];
        for (const { idx } of this.selectedWholesale) {
          body.push({
            idx,
            details: this.details[idx],
            reason: this.reason[idx]
          });
        }

        try {
          const { data } = await Axios.post(
            `${config.hostname}/v1/exchange/create`,
            body,
            {
              withCredentials: true
            }
          );

          if (AxiosMiddleware(data.opcode)) {
            switch (data.opcode) {
              case OPCODE.SUCCESS:
                this.visible = false;
                this.refreshExchanges();
                config.alert.mixin({
                  type: "success",
                  title: "성공적으로 신청하였습니다."
                });
                break;
              default:
                this.visible = false;
                config.alert.mixin({
                  type: "error",
                  title: "오류가 발생하였습니다.\n잠시 후에 다시 시도해주세요."
                });
                break;
            }
          }
        } catch (err) {
          config.alert.mixin({
            type: "error",
            title: "서버와 연결할 수 없습니다.\n인터넷 상태를 확인해주세요."
          });
        }
      }
    }
  }
};
</script>